/* eslint-disable camelcase */
import { User, UserManager, UserManagerSettings } from 'oidc-client';
import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export { User };

@Injectable()
export class AuthService {
    userManager: UserManager;

    constructor(private loginService: LoginService, private router: Router) {
        const settings = {
            authority: this.loginService.OidcSettings?.Authority,
            client_id: this.loginService.OidcSettings?.ClientId,
            redirect_uri: this.loginService.OidcSettings?.RedirectUri,
            silent_redirect_uri:
                this.loginService.OidcSettings?.SilentRedirectUri,
            post_logout_redirect_uri:
                this.loginService.OidcSettings?.PostLogoutRedirectUri,
            response_type: 'id_token token',
            scope: this.loginService.OidcSettings?.Scope,
        };
        this.userManager = new UserManager(settings);
        this.userManager.events.addUserSignedOut(async () => {
            await this.userManager.removeUser();
            this.gotoPostLogoutUrl();
        });
        this.userManager.events.addAccessTokenExpired(async () => {
            await this.userManager.removeUser();
            this.gotoPostLogoutUrl();
        });
    }

    public getUser(): Promise<User> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public renewToken(): Promise<User> {
        return this.userManager.signinSilent();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }

    async signinCallback() {
        try {
            const user = await this.userManager.signinRedirectCallback();
            this.router.navigate(['/login']);
        } catch (error) {
            console.error('oidcHelper.signinRedirectCallback error: ' + error);
            this.gotoPostLogoutUrl();
        }
    }

    async signinSilent() {
        try {
            await this.userManager.signinSilentCallback();
        } catch (error) {
            console.error('oidcHelper.signinSilentCallback error: ' + error);
        }
    }

    isLoggedInObs(): Observable<boolean> {
        return from(this.userManager.getUser()).pipe(map<User, boolean>(
            (user) => {
                if (user) {
                    return true;
                } else {
                    return false;
                }
            }
        ));
    }

    gotoPostLogoutUrl() {
        if (this.loginService.OidcSettings.PostLogoutRedirectUri) {
            window.location.assign(
                this.loginService.OidcSettings.PostLogoutRedirectUri
            );
        } else {
            window.location.reload();
        }
    }
}
